export default __webpack_public_path__ + "static/media/pills@2x.e95cb6fe.png";